<template>
  <FormContainer>
    <template #title>Tuteur</template>
    <template #content>
      <div class="form__bloc">
        <BasicText
          weight="semibold"
          class="col-36"
          color="secondary-600"
        >
          Au sein de l'établissement employeur
        </BasicText>
        <WrapperInput
          id="field_82"
          v-model="nomTuteurEtablissementModel"
          label="Nom"
          :required="meta.tutorat?.tuteurEntrepriseEmployeur?.nom?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseEmployeur?.nom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM_NAIS"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_83"
          v-model="prenomTuteurEtablissementModel"
          label="Prénom"
          :required="meta.tutorat?.tuteurEntrepriseEmployeur?.prenom?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseEmployeur?.prenom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_PRENOM"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInputDate
          id="field_84"
          v-model="dateNaissanceTuteurEtablissementModel"
          label="Date de naissance"
          :required="meta.tutorat?.tuteurEntrepriseEmployeur?.dateNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseEmployeur?.dateNaissance?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE_NAIS"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_85"
          v-model="emploiOccupeTuteurEtablissementModel"
          label="Emploi occupé"
          :required="meta.tutorat?.tuteurEntrepriseEmployeur?.emploiOccupe?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseEmployeur?.emploiOccupe?.$messageErreurDirty!"
          hint="100 caractères max"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_EMPLOI_TUTEUR"
          :maxlength="100"
          deletable
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperToggleSwitch
          v-if="
            meta.tutorat?.tuteurEntrepriseEmployeur?.souhaiteAideFonctionTutorale?.$status !== PropertyStatus.NotPresent
          "
          v-model="souhaiteAideFonctionTutoraleEEModel"
          label="Souhaitez-vous bénéficier de l'aide à l'Exercice de la fonction tutorale pour le tuteur de l’entreprise de travail temporaire ?"
          :items="OuiOuNon"
          :required="
            meta.tutorat?.tuteurEntrepriseEmployeur?.souhaiteAideFonctionTutorale?.$status === PropertyStatus.Required
          "
          :alertLabel="meta.tutorat?.tuteurEntrepriseEmployeur?.souhaiteAideFonctionTutorale?.$messageErreurDirty!"
          :readonly
          nbMaxLines="2"
          class="col-10 col-md-18 col-sm-36"
        />
      </div>
      <div class="form__bloc">
        <BasicText
          weight="semibold"
          class="col-36"
          color="secondary-600"
        >
          Au sein de l’entreprise utilisatrice, si travail temporaire, groupement employeur ou GEIQ
        </BasicText>
        <WrapperInput
          id="field_82"
          v-model="nomTuteurEntrepriseModel"
          label="Nom"
          :required="meta.tutorat?.tuteurEntrepriseUtilisatrice?.nom?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseUtilisatrice?.nom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM_NAIS"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_83"
          v-model="prenomTuteurEntrepriseModel"
          label="Prénom"
          :required="meta.tutorat?.tuteurEntrepriseUtilisatrice?.prenom?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseUtilisatrice?.prenom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_PRENOM"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInputDate
          id="field_84"
          v-model="dateNaissanceTuteurEntrepriseModel"
          label="Date de naissance"
          :required="meta.tutorat?.tuteurEntrepriseUtilisatrice?.dateNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseUtilisatrice?.dateNaissance?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE_NAIS"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_85"
          v-model="emploiOccupeTuteurEntrepriseModel"
          label="Emploi occupé"
          :required="meta.tutorat?.tuteurEntrepriseUtilisatrice?.emploiOccupe?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseUtilisatrice?.emploiOccupe?.$messageErreurDirty!"
          hint="100 caractères max"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_EMPLOI_TUTEUR"
          :maxlength="100"
          deletable
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperToggleSwitch
          v-if="
            meta.tutorat?.tuteurEntrepriseUtilisatrice?.souhaiteAideFonctionTutorale?.$status !==
            PropertyStatus.NotPresent
          "
          v-model="souhaiteAideFonctionTutoraleEUModel"
          label="Souhaitez-vous bénéficier de l'aide à l'Exercice de la fonction tutorale pour le tuteur de l’entreprise utilisatrice ?"
          :items="OuiOuNon"
          :required="
            meta.tutorat?.tuteurEntrepriseUtilisatrice?.souhaiteAideFonctionTutorale?.$status ===
            PropertyStatus.Required
          "
          :alertLabel="meta.tutorat?.tuteurEntrepriseUtilisatrice?.souhaiteAideFonctionTutorale?.$messageErreurDirty!"
          :readonly
          nbMaxLines="2"
          class="col-10 col-md-18 col-sm-36"
        />
      </div>
      <WrapperCheckbox
        id="field_86"
        v-model="attestationTuteurCriteresEligibiliteModel"
        label="L'employeur atteste sur l'honneur que le(s) tuteur(s) répond(ent) à l'ensemble des critères d'éligibilité à cette fonction"
        :alertLabel="meta.tutorat?.attestationTuteurCriteresEligibilite?.$messageErreurDirty!"
        class="col-36"
        :readonly
      />
      <WrapperCheckbox
        id="field_AttestationTuteurTroisStagiaires"
        v-if="meta.tutorat?.attestationTuteurTroisStagiaires?.$status !== PropertyStatus.NotPresent"
        v-model="attestationTuteurTroisStagiairesModel"
        :label="attestationTuteurTroisStagiairesEmployeurLabel"
        :required="meta.tutorat?.attestationTuteurTroisStagiaires?.$status === PropertyStatus.Required"
        :alertLabel="meta.tutorat?.attestationTuteurTroisStagiaires?.$messageErreurDirty!"
        class="col-36"
        :readonly
      />
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
import { useDemandeCPROStore } from '@/features/interface/demande/cpro/useDemandeCPROStore'
import {
  FormContainer,
  HINT_DATE,
  PLACEHOLDER_DATE_NAIS,
  PLACEHOLDER_EMPLOI_TUTEUR,
  PLACEHOLDER_NOM_NAIS,
  PLACEHOLDER_PRENOM,
} from '@/features/interface/demande/shared'
import { OuiOuNon } from '@/features/interface/shared/tools'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

  const store = useDemandeCPROStore()
  const { setupFieldWithKey } = store
  const { meta, readonly, estTT, model } = storeToRefs(store)

  const nomTuteurEtablissementModel = setupFieldWithKey<string>('tutorat.tuteurEntrepriseEmployeur.nom', true)
  const prenomTuteurEtablissementModel = setupFieldWithKey<string>('tutorat.tuteurEntrepriseEmployeur.prenom', true)
  const dateNaissanceTuteurEtablissementModel = setupFieldWithKey<string>(
    'tutorat.tuteurEntrepriseEmployeur.dateNaissance',
    true,
  )
  const emploiOccupeTuteurEtablissementModel = setupFieldWithKey<string>(
    'tutorat.tuteurEntrepriseEmployeur.emploiOccupe',
  )
  const souhaiteAideFonctionTutoraleEEModel = setupFieldWithKey<string>(
    'tutorat.tuteurEntrepriseEmployeur.souhaiteAideFonctionTutorale',
    true,
  )
  const souhaiteAideFonctionTutoraleEUModel = setupFieldWithKey<string>(
    'tutorat.tuteurEntrepriseUtilisatrice.souhaiteAideFonctionTutorale',
    true,
  )
  const nomTuteurEntrepriseModel = setupFieldWithKey<string>('tutorat.tuteurEntrepriseUtilisatrice.nom', true)
  const prenomTuteurEntrepriseModel = setupFieldWithKey<string>('tutorat.tuteurEntrepriseUtilisatrice.prenom', true)
  const dateNaissanceTuteurEntrepriseModel = setupFieldWithKey<string>(
    'tutorat.tuteurEntrepriseUtilisatrice.dateNaissance',
    true,
  )
  const emploiOccupeTuteurEntrepriseModel = setupFieldWithKey<string>(
    'tutorat.tuteurEntrepriseUtilisatrice.emploiOccupe',
  )
  const attestationTuteurCriteresEligibiliteModel = setupFieldWithKey<boolean>(
    'tutorat.attestationTuteurCriteresEligibilite',
  )
  const attestationTuteurTroisStagiairesModel = setupFieldWithKey<boolean>('tutorat.attestationTuteurTroisStagiaires')

  const attestationTuteurTroisStagiairesEmployeurLabel = computed(() => {
    return estTT.value && model.value?.typePublic === 'Interimaire'
      ? "L'employeur atteste sur l'honneur que le tuteur de l’entreprise utilisatrice ne soit pas responsable de plus de 3 stagiaires et pas plus de 2 stagiaires si le tuteur est également l'employeur, et, que le tuteur de l'établissement employeur ne soit pas responsable de plus de 10 stagiaires"
      : "L'employeur atteste sur l'honneur que le tuteur ne soit pas responsable de plus de 3 stagiaires et pas plus de 2 stagiaires si le tuteur est également l'employeur"
  })
</script>

